import { createContext, useState, useContext } from "react";
// import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import CONSTANT from "../constants/Constant";
import DirectToConsumerService from "../services/DirectToConsumerService";
import AppContext from "../contexts/AppContext";

const DirectPaymentContext = createContext();

export const DirectPaymentProvider = ({ children }) => {
    const { userInfo } = useContext(AppContext);

    const [sessionId, setSessionId] = useState('');
    const [packageId, setPackageId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [isRegisteredUser, setIsRegisteredUser] = useState(false);
    const [isNewUserFromDirectPayment, setIsNewUserFromDirectPayment] = useState(false);

    const patientFullName = userInfo?.FullName || '';

    const handleDirectPayment = async (search) => {
        // const search = location.search;
        const queryString = search.includes('?') ? search.split('?')[1] : '';
        const query = new URLSearchParams(queryString);
        let sessionId = query.get(CONSTANT.QUERY_PARAM.SESSION_ID) || '';
        let packageId = query.get(CONSTANT.QUERY_PARAM.PACKAGE_ID_FOR_DIRECT_PAYMENT) || '';

        if (sessionId && packageId) {
            setSessionId(sessionId);
            setPackageId(packageId);

            setIsLoading(true);

            try {
                const response = await DirectToConsumerService.stripeDirectPaymentVerification({
                    SessionId: sessionId,
                    PackageGId: packageId
                });

                if (response.success) {
                    const data = response?.data || {};
                    const patientEmail = data?.Email || '';
                    const isPatientRegistered = data?.IsRegister || false;

                    if (patientEmail) {
                        setEmail(patientEmail);
                        setIsRegisteredUser(isPatientRegistered);
                    }
                } else {
                    toast.error("Internal Server Error, Please refresh the page");
                }
            } catch (error) {
                console.error("Payment verification error:", error);
                toast.error("Failed to verify payment");
            } finally {
                setIsLoading(false);
            }
        } else {
            setIsLoading(false);
        }
    };

    const clearDirectPaymentState = () => {
        setSessionId('');
        setPackageId('');
        setIsLoading(false);
        setEmail('');
        setIsRegisteredUser(false);
    };


    return (
        <DirectPaymentContext.Provider
            value={{
                sessionId,
                packageId,
                isLoading,
                email,
                isRegisteredUser,
                patientFullName,
                isNewUserFromDirectPayment,
                handleDirectPayment,
                clearDirectPaymentState,
                setIsNewUserFromDirectPayment,
            }}
        >
            {children}
        </DirectPaymentContext.Provider>
    );
};

export const useHandleDirectPayment = () => {
    const context = useContext(DirectPaymentContext);

    if (context === undefined) {
        throw new Error("useHandleDirectPayment must be used within a DirectPaymentProvider");
    }

    return context;
};
